import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  req_single_list_tqa_reviewOpinion,
  req_single_tqa_reviewCheck,
  req_edit_tqa_reviewOpinion,
} from "../../api";
import { Card, Table, Divider, Alert, Radio, Input, message } from "antd";

const { TextArea } = Input;
class ReviewSchoolCommitModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    worker: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    questions: [
      "一、院及系所依據基本素養及核心能力訂定學生學習成效檢核方式及落實情形。",
      "二、院及系所能依據評量結果修訂課程內容。",
      "三、院及系所提升學生實務能力之具體措施。",
      "四、院及系所符合完整之發展與回饋機制。",
      "五、其他有關增進學生學習意願及提升學習成效之具體做法。",
    ],
    options: [
      { label: "非常符合", value: "非常符合" },
      { label: "符合", value: "符合" },
      { label: "普通", value: "普通" },
      { label: "不符合", value: "不符合" },
      { label: "非常不符合", value: "非常不符合" },
    ],
    Checkdata: {},
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {
    this.api_single_checkitem();
    this.api_single_opinionitem();
  }
  // 遠端數據處理 //////////////////////////////////////////////
  api_single_opinionitem = async () => {
    const { WorkManualVersion, WorkTypeCode, ContentUserCode } =
      this.props.worker;
    const { token } = this.props.user;
    //console.log(this.props.worker);
    const result = await req_single_list_tqa_reviewOpinion(
      WorkManualVersion,
      ContentUserCode,
      WorkTypeCode,
      token
    );
    if (result.total > 0) {
      this.setState({ items: result.data });
    } else {
      this.setState({ OpinionData: [] });
    }
  };

  api_single_checkitem = async () => {
    const { WorkTypeCode, WorkManualVersion, ContentUserCode } =
      this.props.worker;
    const { token } = this.props.user;

    const result = await req_single_tqa_reviewCheck(
      WorkManualVersion,
      ContentUserCode,
      WorkTypeCode,
      token
    );
    if (result) {
      this.setState({ Checkdata: result });
      console.log("Checkdata:", result);
    } else {
      this.setState({ Checkdata: null });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_tqa_reviewOpinion(item, token);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    this.init_columns();
  };

  init_columns = () => {
    this.columns = [
      {
        title: "頁數",
        dataIndex: "TagCode",
        key: "TagCode",
        width: 20,
        render: (text) => <>{text}</>,
      },
      {
        title: "檢核意見",
        dataIndex: "ContentDescription",
        key: "ContentDescription",
        width: 40,
      },
      {
        title: "回復意見",
        key: "CommitDescription",
        width: 50,
        render: (item) => {
          const { WorkManualStatus } = this.props.worker;
          const { CommitDescription } = item;
          return (
            <>
              {WorkManualStatus === "DONE" ? (
                <>{CommitDescription}</>
              ) : (
                <>
                  {" "}
                  <TextArea
                    id="CommitDescription"
                    rows={2}
                    defaultValue={CommitDescription}
                    allowClear
                    onChange={(e) => this.onChangeTextArea(e, item)}
                  />
                </>
              )}
            </>
          );
        },
      },
      {
        title: "",
        width: 25,
        fixed: "right",
        render: (item) => {
          const { WorkManualStatus } = this.props.worker;
          return (
            <>
              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: "82px" }}
                onClick={() => this.handle_show_ui_modal("EDIT", item)}
                disabled={WorkManualStatus === "DONE"}
              >
                <i className="fa fa-check-circle"></i> 儲存
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_show_ui_modal = (modal, item) => {
    const { CommitUserCode } = this.props.worker;
    switch (modal) {
      case "EDIT":
        item.condition = "COMMIT";
        item.CommitUserCode = CommitUserCode;
        this.api_modify_item(item);
        console.log(item);
        break;
      default:
    }
  };

  onChangeTextArea = (e, obj) => {
    const { items } = this.state;

    items.filter(function (item) {
      if (item.WorkManualVersion === obj.WorkManualVersion) {
        Object.keys(item).forEach((propertyName) => {
          if (e.target.id === propertyName && e.target.value !== null) {
            item[propertyName] = e.target.value.trim();
          }
        });
      }
      return item;
    });

    this.setState({ items });
  };

  render() {
    const { questions, options, Checkdata, items } = this.state;
    const checkview = Checkdata ? (
      <>
        <Alert message={questions[0]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueA} />
        <p></p>
        <Alert message={questions[1]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueB} />
        <p></p>
        <Alert message={questions[2]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueC} />
        <p></p>
        <Alert message={questions[3]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueD} />
        <p></p>
        <Alert message={questions[4]} type="info" showIcon />
        <p></p>
        <Radio.Group options={options} value={Checkdata.ChoicedValueE} />
      </>
    ) : null;
    return (
      <Card>
        <Table
          bordered
          scroll={{ y: 480 }}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={false}
          columns={this.columns}
        />
        <Divider />
        {checkview}
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewSchoolCommitModal);
